<template>
  <div
    :id="id"
    class="rs-dragndrop"
  >
    <Container
      :orientation="orientation"
      :behaviour="behaviour"
      :tag="tag"
      :group-name="groupName"
      :lock-axis="lockAxis"
      :drag-handle-selector="dragHandleSelector"
      :non-drag-area-selector="nonDragAreaSelector"
      :drag-begin-delay="dragBeginDelay"
      :animation-duration="animationDuration"
      :auto-scroll-enabled="autoScrollEnabled"
      :drag-class="dragClass"
      :drop-class="dropClass"
      :remove-on-drop-out="removeOnDropOut"
      :drop-placeholder="dropPlaceholder"
      :get-child-payload="getChildPayload"
      :should-accept-drop="shouldAcceptDrop"
      :should-animate-drop="shouldAnimateDrop"
      :get-ghost-parent="getGhostParent"
      @drag-start="onDragStart"
      @drag-end="onDragEnd"
      @drop-ready="onDropReady"
      @drop="onDrop"
    >
      <slot />
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Container } from 'vue-smooth-dnd';

export interface IDropResult {
  removedIndex: number;
  addedIndex: number;
  payload: Object;
}

export default defineComponent({
  name: 'RsDragndrop',
  components: {
    Container,
  },
  props: {
    id: String,
    orientation: {
      type: String,
      default: 'vertical',
    },
    behaviour: {
      type: String,
      default: 'move',
      validator: (prop: string) => ['move', 'copy'].includes(prop),
    },
    tag: {
      type: [String, Object],
      default: 'div',
    },
    groupName: String,
    lockAxis: String,
    dragHandleSelector: String,
    nonDragAreaSelector: String,
    dragBeginDelay: {
      type: Number,
      default: 0,
    },
    animationDuration: {
      type: Number,
      default: 250,
    },
    autoScrollEnabled: {
      type: Boolean,
      default: true,
    },
    dragClass: String,
    dropClass: String,
    removeOnDropOut: Boolean,
    dropPlaceholder: [Boolean, Object],
    getChildPayload: Function,
    shouldAcceptDrop: Function,
    shouldAnimateDrop: Function,
    getGhostParent: Function,
  },
  data() {
    return {
      Muuri: null,
      draggableBlocks: [] as Array<HTMLElement>,
    };
  },
  methods: {
    onDragStart(dragResult: IDropResult) {
      this.$emit('drag-start', dragResult);
    },
    onDragEnd(dragResult: IDropResult) {
      this.$emit('drag-end', dragResult);
    },
    onDropReady(dropResult: IDropResult) {
      this.$emit('drop-ready', dropResult);
    },
    onDrop(dropResult: IDropResult) {
      this.$emit('drop', dropResult);
    },
  },
});
</script>

<style lang="scss" scoped>
  @import '@/styles/_variables.scss';
  .rs-dragndrop {
    color: inherit;
  }
</style>
